// extracted by mini-css-extract-plugin
module.exports = {"container":"CloseButton_container__kAUzZ","closeIcon":"CloseButton_closeIcon__9uUIp"};